'use client';

import { useEffect } from 'react';
import { setShadowRootStyle } from '../../common';
import { DealerStore } from '../dealerStoreType';
import { SELECTED_STORE_ID } from '../constants';

interface DealerLocatorSearchResultsProps {
  children: ({ store }: { store: DealerStore }) => React.ReactNode;
  visibleStores: DealerStore[];
}

export const DealerLocatorSearchResults = ({
  children,
  visibleStores
}: DealerLocatorSearchResultsProps) => {
  // Fixing style issues inside shadow-root of Blocks components
  const searchResults = document.getElementsByName(SELECTED_STORE_ID);
  const areResultsLoaded = searchResults.length === visibleStores.length;
  useEffect(() => {
    if (areResultsLoaded) {
      searchResults?.forEach((element) => {
        // Fix background color on radio button label on hover
        setShadowRootStyle(element, 'label', 'background-color', 'unset');
      });
    }
  }, [areResultsLoaded, searchResults]);

  return <>{visibleStores.map((store) => children({ store }))}</>;
};
